/**
 * Returns whether a plugin ID uses the character set accepted by block runtime
 * metadata normalization.
 */
export const isValidPluginId = (value) => /^[a-zA-Z0-9._-]+$/.test(value);
/**
 * Resolves unknown runtime mode input to the SDK default, `preview-only`.
 */
export const resolveBlockRuntimeMode = (value) => {
    if (value === 'storefront-runtime')
        return 'storefront-runtime';
    if (value === 'admin-only')
        return 'admin-only';
    return 'preview-only';
};
/**
 * Sanitizes persisted or manifest-provided runtime metadata, removing invalid
 * plugin ownership and config version values.
 */
export const normalizeBlockRuntimeMetadata = (input, options) => {
    const pluginIdCandidate = typeof input.pluginId === 'string' ? input.pluginId.trim() : '';
    const pluginId = pluginIdCandidate && isValidPluginId(pluginIdCandidate)
        ? pluginIdCandidate
        : undefined;
    const configVersionCandidate = Number(input.configVersion);
    const configVersion = Number.isInteger(configVersionCandidate) && configVersionCandidate > 0
        ? configVersionCandidate
        : undefined;
    const preserveWithoutOwner = options?.preserveRuntimeModeWithoutPluginId === true;
    const hasExplicitRuntimeMode = input.runtimeMode === 'storefront-runtime' ||
        input.runtimeMode === 'preview-only' ||
        input.runtimeMode === 'admin-only';
    if (!pluginId && !preserveWithoutOwner) {
        return {
            ...(configVersion ? { configVersion } : {}),
        };
    }
    if (!pluginId && preserveWithoutOwner && !hasExplicitRuntimeMode) {
        return {
            ...(configVersion ? { configVersion } : {}),
        };
    }
    return {
        ...(pluginId ? { pluginId } : {}),
        runtimeMode: resolveBlockRuntimeMode(input.runtimeMode),
        ...(configVersion ? { configVersion } : {}),
    };
};
